var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notifications-empty empty"},[_c('img',{attrs:{"src":_vm.content.image}}),_c('div',{staticClass:"empty__title"},[_vm._v(_vm._s(_vm.content.title))]),_c('div',{staticClass:"empty__description"},[_vm._v(_vm._s(_vm.content.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }